function NotFound(){

    return (
        <>
            <h1>404. NotFound</h1>
        </>
    )
}
export default NotFound;